import {
  CREATE_USER_API,
  GET_ALL_USERNAME_API,
  GET_USER_API,
  SEARCH_USER_API,
  UPDATE_USER_API,
  CHANGE_PASSWORD_API,
  DELETE_USERS_API,
  GET_PASSWORD_POLICY_API
} from '~/constants/APIs'
import {
  IChangePasswordForm,
  IPasswordPolicy,
  IUser,
  IUserForm,
  IUserListData,
  IUserSearchRequest
} from '~/models'
import axiosClient from './axiosClient'

export const userApis = {
  searchUser: (params: IUserSearchRequest) =>
    axiosClient.get(SEARCH_USER_API, { params }) as unknown as IUserListData,
  getUser: (userName: string) =>
    axiosClient.get(GET_USER_API + userName) as unknown as IUser,
  updateUser: (data: IUserForm) => axiosClient.put(UPDATE_USER_API + data.userName, data),
  createUser: (data: IUserForm) => axiosClient.post(CREATE_USER_API, data),
  getAllUsername: () => axiosClient.get(GET_ALL_USERNAME_API) as unknown as string[],
  changePassword: (data: IChangePasswordForm) =>
    axiosClient.post(CHANGE_PASSWORD_API, data),
  deleteUsers: (data: string[]) => axiosClient.delete(DELETE_USERS_API, { data }),
  getPasswordPolicy: () =>
    axiosClient.get(GET_PASSWORD_POLICY_API) as unknown as IPasswordPolicy
}
